<div *ngIf="modo==='normal'">
  <section class="flex items-center justify-center py-4">
    <div class="relative bg-surface max-w-[440px] w-full h-fit max-h-[85vh] rounded-lg shadow-vanguard overflow-hidden flex flex-col">
      <button type="button" class="modal-close-x" (click)="cerrarModale('login-modal-1')" aria-label="Cerrar">&times;</button>
      <div class="p-5 sm:p-6 flex flex-col overflow-y-auto min-h-0">
        <div class="w-full max-w-[440px] mx-auto">
          <div class="text-2xl sm:text-3xl font-extrabold text-text-main mb-1 text-center">
            Iniciar sesión
          </div>
          <div class="text-sm text-text-muted mb-4 text-center">
            Inicia sesión para comenzar tu compra.
          </div>

          <form [formGroup]="loginform" (ngSubmit)="submitForm()" class="flex flex-col gap-3">
            <div *ngIf="loginform.errors && loginform.invalid" class="bg-[color-mix(in_srgb,var(--accent-color),white_85%)] text-accent rounded-md px-4 py-2 text-sm text-center">
              {{errorgen}}
            </div>

            <label class="flex flex-col gap-1.5">
              <span class="text-xs font-bold uppercase tracking-wide text-text-main">Usuario o Mail</span>
              <input class="w-full h-[44px] border border-border rounded-md px-4 text-[15px] bg-surface text-text-main transition-base duration-base focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary-light"
                type="email" [formControlName]="'username'" autocomplete="username" autoCapitalize="none"/>
              <div *ngIf="formFields.username.touched && formFields.username.invalid" class="text-accent text-xs">
                <div *ngIf="formFields.username.errors.required">Este campo no puede estar vacío.</div>
              </div>
            </label>

            <label class="flex flex-col gap-1.5">
              <div class="flex items-center justify-between">
                <span class="text-xs font-bold uppercase tracking-wide text-text-main">Contraseña</span>
                <span class="text-xs text-text-muted underline cursor-pointer hover:text-primary" (click)="resetPass()" id="registroHab" [ngStyle]="{display: registroHab}">¿Olvidaste tu contraseña?</span>
              </div>
              <input class="w-full h-[44px] border border-border rounded-md px-4 text-[15px] bg-surface text-text-main transition-base duration-base focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary-light"
                type="password" [formControlName]="'password'" autocomplete="current-password" autocapitalize="none" />
              <div *ngIf="formFields.password.touched && formFields.password.invalid" class="text-accent text-xs">
                <div *ngIf="formFields.password.errors.required">Este campo no puede estar vacío.</div>
              </div>
            </label>

            <ui-button type="submit" variant="primary" [fullWidth]="true" [disabled]="!loginform.valid" class="mt-1">
              Ingresar
            </ui-button>

            <ui-button type="button" variant="secondary" [fullWidth]="true" id="registroHab" [ngStyle]="{display: registroHab}" (click)="createUser()">
              Registrarme
            </ui-button>

            <div class="text-center" id="registroHab" [ngStyle]="{display: beneficiosTrue}">
              <span class="text-sm text-primary underline cursor-pointer hover:text-primary-hover" (click)="resetPass()">Reestablecer Contraseña</span>
            </div>

            <div class="flex items-center gap-3 text-text-muted text-sm">
              <span class="flex-1 h-px bg-border"></span>
              <span>o continuá con</span>
              <span class="flex-1 h-px bg-border"></span>
            </div>

            <div class="flex flex-col gap-3">
              <div class="flex items-start justify-center h-11 overflow-hidden" *ngIf="mostrarLoginGoogle && googleButtonReady">
                <asl-google-signin-button type="standard" size="large" shape="rectangular" theme="outline"
                  text="signin_with" logo_alignment="left" [width]="anchoBotonGoogle" locale="es"></asl-google-signin-button>
              </div>
              <button type="button" *ngIf="mostrarLoginCodigoMail"
                class="flex items-center justify-center gap-2 border border-border rounded-md h-[46px] text-sm font-medium text-text-main transition-base duration-base hover:bg-bg-app"
                (click)="codigoAccesoPorMail()">
                <i class="mdi mdi-email-outline text-lg"></i>
                Código de acceso por mail
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</div>
<modal-open-point id="create-user-modal-1">

  <div normal class="mybody">
    <create-user-mmax></create-user-mmax>
    <div class="cerrarC" (click)="cerrarModale('create-user-modal-1')">X</div>
  </div>

</modal-open-point>
<modal-open-point id="reset-pass-modal-1">

  <div normal class="mybody">
    <reset-pass-mmax></reset-pass-mmax>
    <div class="cerrarR" (click)="cerrarModale('reset-pass-modal-1')">X</div>
  </div>

</modal-open-point>

<modal-open-point id="restore-pass-modal">
  <div normal class="mybody">
    <restore-pass-mmax></restore-pass-mmax>
    <div class="cerrarR" (click)="cerrarModale('restore-pass-modal')">X</div>
  </div>
</modal-open-point>

<modal-open-point id="send-reset-pass-modal-1">
  <div normal class="mybody">
    <send-reset-pass></send-reset-pass>
    <div class="cerrarR" (click)="cerrarModale('send-reset-pass-modal-1')">X</div>
  </div>
</modal-open-point>

<modal-open-point id="modal-alert-pass">
  <div normal>
    <modal-alert-pass></modal-alert-pass>
  </div>
</modal-open-point>

<modal-open-point id="modal-seleccione-suc">
  <div normal>
    <modal-seleccione-suc></modal-seleccione-suc>
  </div>
</modal-open-point>

<modal-open-point id="modal-pass-error">
  <div normal>
    <modal-pass-error></modal-pass-error>
  </div>
</modal-open-point>
